<!-- <ng-container *ngIf="preferences$ | async as preferences"> -->
<!-- <ng-container *ngIf="preferencesData.length > 0"> -->
<!-- <ng-container *ngIf="preferencesData.length"> -->

@if (preferencesData.length) {
  <div class="email-preferences">
    <div class="row d-flex justify-content-left">
      <div class="col-md-8">
        <div class="pref-header">
          {{ 'notificationPreference.message' | cxTranslate }}
          <!-- Manage your email and notification preferences here. Your email notifications are sent to: -->
        </div>
        <div class="form-check cx-notification-channels">
          @for (preference of preferencesData; track preference) {
            @if (preference.visible) {
              <mat-slide-toggle
                [checked]="preference.enabled"
                (change)="updatePreference(preference)"
                [disabled]="isLoading$ | async"
                >
                <!-- <span><strong>{{'notificationPreference.' + preference.channel | cxTranslate}}</strong></span> -->
                <span
                  ><strong>{{ 'notificationPreference.' + preference.channel | cxTranslate }}</strong></span
                  >
                  {{ preference.value }}
                </mat-slide-toggle>
              }
            }
          </div>
          <label class="pref-note"
            ><strong>{{ 'notificationPreference.note' | cxTranslate }}</strong
            >{{ 'notificationPreference.noteMessage' | cxTranslate }}
          </label>
        </div>
      </div>
    </div>
    <ng-template #loading>
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    </ng-template>
  }
  <!-- spinner -->
  @if (showSpinnerOnDataLoad) {
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  }
